// extracted by mini-css-extract-plugin
export default {"tag":"GroupProfileTags_tag__8byMH"};